// test1022
(1022 && 0);
